// Copyright (C) 2020-2025 Skylark Drones

import apiInstance from '@/config'

export function registerUser(data, verificationToken) {
  return apiInstance.publicHttp.post('/register', data, {
    headers: { Authorization: verificationToken }
  })
}

/**
 * Creates sample sites and collections for the given company
 */
export function createSampleSites(companyID) {
  return apiInstance.http.post(`/register/sample_sites/${companyID}`)
}
